import React, { useMemo } from 'react'
import { IClinicNumber, IPortDetailsStep2 } from '@dataTypes/clinic.type'
import {
  formatPhoneNumber,
  normalizePhoneNumber,
} from '@utils/numberFormatter.util'
import { useAppSelector } from '@store/hooks'
import ReviewSections from '../../../shared/ReviewSections'

interface ReviewInfoProps {
  numberData: IClinicNumber
  detailsStep2Data: IPortDetailsStep2
}

const ReviewInfo: React.FC<ReviewInfoProps> = ({
  numberData,
  detailsStep2Data,
}) => {
  const clinicData = useAppSelector((state) => state.clinic.selectedClinic)
  const selectedNumbers = useMemo(
    () =>
      numberData.phone_number
        .split('\n')
        .map((item) => item.trim())
        .filter((item) => item !== '')
        .map((item) => formatPhoneNumber(normalizePhoneNumber(item), false)),
    [numberData.phone_number],
  )

  return (
    <ReviewSections
      sections={[
        {
          id: 'number',
          title: 'Number',
          showInfo: true,
          fields: [
            {
              label: 'Selected number',
              value: selectedNumbers.join(', ') || '-',
            },
            { label: 'Carrier', value: numberData.phone_carrier || '-' },
          ],
        },
        {
          id: 'authorization',
          title: 'Authorization',
          showInfo: true,
          fields: [
            {
              label: 'Authorizing person',
              value: detailsStep2Data.full_name || '-',
            },
            {
              label: 'Email address',
              value: detailsStep2Data.email_address || '-',
            },
          ],
        },
        {
          id: 'location',
          title: 'Location',
          showInfo: true,
          fields: [
            { label: 'Address', value: clinicData?.address || '-' },
            { label: 'City', value: clinicData?.city || '-' },
            { label: 'State', value: clinicData?.state || '-' },
            { label: 'ZIP', value: clinicData?.zip || '-' },
          ],
        },
      ]}
    />
  )
}

export default ReviewInfo
